class CollectionListCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.collection-carousel-slider');
    this.sliderItems = this.querySelectorAll('.collection-carousel-slide');
    this.enableSliderLooping = false;
    this.currentPage = 0;
    
    if (!this.slider || !this.sliderItems.length) return;
    
    this.initSlider();
    this.setSlideVisibility();
    this.slider.addEventListener('scroll', this.update.bind(this));
  }

  initSlider() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderItemOffset = this.sliderItemsToShow[1]?.offsetLeft - this.sliderItemsToShow[0]?.offsetLeft || 0;
    
    if (this.sliderItemsToShow.length < 2) return;
    
    this.slider.setAttribute('role', 'list');
    this.sliderItems.forEach((slide) => {
      slide.setAttribute('role', 'listitem');
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (button) {
        if (index === this.currentPage) {
          button.removeAttribute('tabindex');
        } else {
          button.setAttribute('tabindex', '-1');
        }
      }
    });
  }

  update() {
    if (!this.slider || !this.sliderItems.length) return;
    
    const previousPage = this.currentPage;
    const scrollLeft = this.slider.scrollLeft;
    this.currentPage = Math.round(scrollLeft / this.sliderItemOffset);
    
    if (this.currentPage !== previousPage) {
      this.setSlideVisibility();
    }
  }
}

customElements.define('collection-list-carousel', CollectionListCarousel);
